export const EmployeePermission = (json: IEmployeePermissions): IEmployeePermissions => {
	const fromJSON = () => {
		const { ...rest } = json

		return {
			...rest,
		}
	}

	return { ...fromJSON() }
}

export const employeePermissionToJSON = (obj: Partial<IEmployeePermissions>): Partial<IEmployeePermissions> => {
	const { ...rest } = obj
	return {
		...rest,
	}
}

export const EmployeeRole = (json: IEmployeeRole): IEmployeeRole => {
	const fromJSON = () => {
		const { ...rest } = json

		return {
			...rest,
		}
	}

	return { ...fromJSON() }
}

export const employeeRoleToJSON = (obj: Partial<IEmployeeRole>): Partial<IEmployeeRole> => {
	const { ...rest } = obj
	return {
		...rest,
	}
}
